import moment from "moment";
import { CampaignServices } from "@/services/campaigns";
import { MEMBERS_ENDPOINTS } from "@/services/members";

export const CampaignMixin = {
  data() {
    return {
      campaign: null,
      campaignId: null,
    };
  },
  watch: {
    "$route.params.campaignId": {
      immediate: true,
      handler() {
        this.setCampaign();
      },
    },
    "$route.params.id_member": {
      immediate: true,
      handler() {
        this.setMember();
      },
    },
    "$store.state.language"() {
      this.setStoreCampaignName();
    },
  },
  computed: {
    campaignName() {
      if (!this.campaign) {
        return;
      }
      const year = moment(this.campaign.date_start).year();
      return `${year}`;
    },
  },
  mounted() {
    this.setMember();
  },
  methods: {
    async getCampaignMember(fileId) {
      const { data } = await this.$request({
        url: MEMBERS_ENDPOINTS.fileDetail(this.campaignId, fileId),
      });
      return data;
    },
    setMember(memberId = null) {
      if (!memberId && this.$route.query.id_member)
        memberId = this.$route.query.id_member;
      if (memberId) this.$store.commit("set", ["memberId", memberId]);
    },
    async setCampaign() {
      if (!this.$route.params.campaignId) {
        this.campaignId = null;
        this.campaign = null;
      } else {
        this.campaignId = this.$route.params.campaignId;
        const { res, data } = await CampaignServices.fetchCampaign(
          this.campaignId
        );
        this.campaign = res.status === 200 ? data : null;
        if (!this.campaign) {
          await this.$router.push({ name: "NotFound" });
        }
      }
      this.setStoreCampaignName();
    },
    setStoreCampaignName() {
      this.$store.commit("set", ["campaignName", this.campaignName]);
    },
  },
};
